const currentHost = window.location.host

export let subdomain = process.env.REACT_APP_SUBDOMAIN
if (currentHost.indexOf(`localhost`) === -1) {
  subdomain = window.location.hostname.split('.')[0]
}
localStorage.setItem('subdomain', subdomain)

export const FILE_DOWNLOAD_PATH = 'downloads'

export const FILE_UPLOAD_PATH = 'upload'

export const CSV_GENERATOR_PATH = 'csv'

export const CSV_SCHOOLS_PATH = `schools`

export const SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME = 'schoolleiderschap'
export const DIGIKAPITAAL_SUBDOMAIN_NAME = 'digikapitaal'

const graphqlEndpointName = process.env.REACT_APP_GRAPHQL_ENDPOINT_NAME || 'graphql'

export const createServerUriWithSubdomain = subdomain => {
  if (
    process.env.REACT_APP_SERVER_URI &&
    process.env.REACT_APP_SERVER_URI.indexOf('localhost') === -1
  ) {
    const url = new URL(process.env.REACT_APP_SERVER_URI)
    const { hostname, protocol } = url

    // we want to replace always the second part of the host
    let newHostName = hostname
      .split('.')
      .map((val, index) => {
        if (index === 1) {
          return subdomain
        }
        return val
      })
      .join('.')
    return `${protocol}//${newHostName}/${graphqlEndpointName}`
  } else return `http://localhost:4000/${graphqlEndpointName}`
}

export const SERVER_GRAPHQL_API_URI = createServerUriWithSubdomain(SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME)

export const API_ROOT = SERVER_GRAPHQL_API_URI.replace(graphqlEndpointName, '')
